import { t } from "i18next";

export const toLocalDateString = (date: Date) =>
  new Date(date.getTime() - date.getTimezoneOffset() * 60_000).toISOString();

/** The day a `toLocalDateString` stands for, at local midnight. */
export const fromLocalDateString = (value: string) =>
  new Date(`${value.slice(0, 10)}T00:00:00`);

export const formatDate = (
  date: Date,
  locale: string,
  options: Intl.DateTimeFormatOptions,
) => {
  const formatter = new Intl.DateTimeFormat(locale, options);
  return formatter.format(date);
};

export const formatDateRange = (
  startDate: Date,
  endDate: Date,
  locale: string,
  options: Intl.DateTimeFormatOptions,
) => {
  const formatter = new Intl.DateTimeFormat(locale, options);
  return formatter.formatRange(startDate, endDate);
};

export const formatRelativeDate = (
  {
    date,
    unit,
  }: {
    date: number;
    unit: Intl.RelativeTimeFormatUnit;
  },
  locale: string,
  options: Intl.RelativeTimeFormatOptions,
) => {
  const formatter = new Intl.RelativeTimeFormat(locale, options);
  return formatter.format(date, unit);
};

export const formatRelativeDay = (
  date: number,
  locale: string,
  options: Intl.RelativeTimeFormatOptions,
) => {
  if (date === 0) {
    return t("date.today");
  }
  return formatRelativeDate({ date: date, unit: "day" }, locale, options);
};
